/** Compact number formatter: 1234 -> "1,234", 1_250_000 -> "1.25M". */
export function formatNumber(n: number, options: Intl.NumberFormatOptions = {}): string {
  return new Intl.NumberFormat('en-US', options).format(n);
}

export function formatPercent(value: number, fractionDigits = 1): string {
  return `${value.toFixed(fractionDigits)}%`;
}

export function formatDate(iso: string, opts?: Intl.DateTimeFormatOptions): string {
  return new Date(iso).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    ...opts,
  });
}

export function formatTime(iso: string): string {
  return new Date(iso).toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}

/** "May 1, 2026 · 14:32:05" — used in tables that need the full picture. */
export function formatDateTime(iso: string): string {
  const d = new Date(iso);
  const date = d.toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  });
  const time = d.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
  return `${date} · ${time}`;
}

/** Mask all but the last `visible` characters, e.g. "+96655551234" -> "+••••••••1234". */
export function maskMsisdn(msisdn: string, visible = 4): string {
  if (msisdn.length <= visible) return msisdn;
  const suffix = msisdn.slice(-visible);
  return `${msisdn[0] === '+' ? '+' : ''}${'•'.repeat(Math.max(msisdn.length - visible - 1, 4))}${suffix}`;
}
